
$(document).ready(function () {
    'use strict';

    // =========================================================
    // SETTINGS
    // =========================================================

    var isDeliveryValid = false;
    var activeDeliveryMode = '';

    var loaderTimeout = null;
    var checkerTimeout = null;
    var datesTimeout = null;
    var tabChangeId = 0;

    var SELECTORS = {
        main: '.identixweb-order-delivery-date-main',
        tabs: '.identixweb-order-delivery-tab',
        future: '.shipping-identixweb-order-delivery-date',
        sameDay: '.local-delivery-identixweb-order-delivery-date',
        pickup: '.store-pickup-identixweb-order-delivery-date',
        checker: '.added-delivery-identixweb-order-delivery-date',
        dates: '.shipping-identixweb-order-delivery-dates',
        time: '.identixweb-order-delivery-deliveryTime',
        checkout:
            'button[name="checkout"], ' +
            'input[name="checkout"], ' +
            '#checkout, ' +
            '.cart__checkout-button'
    };

    function $cartChecker() {
        return $(SELECTORS.checker);
    }

    function getCheckoutButtons() {
        return $(SELECTORS.checkout);
    }

    // =========================================================
    // DELIVERY DATA FROM deliveries.js
    // =========================================================

    function findDelivery(postcode) {
        if (
            typeof deliveries === 'undefined' ||
            !Array.isArray(deliveries)
        ) {
            console.error('deliveries.js is not loaded.');
            return null;
        }

        var code = String(postcode || '').trim();

        return deliveries.find(function (item) {
            return String(item.code).trim() === code;
        }) || null;
    }

    function getDeliveryDay(item) {
        return String((item && item.day) || '')
            .trim()
            .toLowerCase();
    }

    function formatDeliveryPrice(item) {
        if (
            !item ||
            item.price === null ||
            item.price === undefined ||
            item.price === ''
        ) {
            return null;
        }

        var price = Number(item.price);

        if (!Number.isFinite(price) || price < 0) {
            return null;
        }

        return '$' + price.toFixed(2);
    }

    // =========================================================
    // DATE PARSING
    // =========================================================

    function parseDeliveryDate(value) {
        if (!value) return null;

        value = String(value).trim();

        var match;
        var year;
        var month;
        var day;

        // Australian DD/MM/YYYY
        match = value.match(
            /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/
        );

        if (match) {
            day = Number(match[1]);
            month = Number(match[2]);
            year = Number(match[3]);
        }

        // YYYY-MM-DD
        if (!match) {
            match = value.match(
                /^(\d{4})-(\d{1,2})-(\d{1,2})$/
            );

            if (match) {
                year = Number(match[1]);
                month = Number(match[2]);
                day = Number(match[3]);
            }
        }

        if (!match) return null;

        var date = new Date(year, month - 1, day);

        if (
            date.getFullYear() !== year ||
            date.getMonth() !== month - 1 ||
            date.getDate() !== day
        ) {
            return null;
        }

        return date;
    }

    // =========================================================
    // SELECTED DELIVERY DATE
    // =========================================================

    function getSelectedDeliveryDate() {
        var selectedDate = null;
        var $main = $(SELECTORS.main);

        $main.find('input').each(function () {
            var $input = $(this);

            if (
                $input.is(
                    '.order-delivery-date-postalcode, ' +
                    '#deliveryPostcode, [type="hidden"]'
                )
            ) {
                return;
            }

            var date = parseDeliveryDate($input.val());

            if (date) {
                selectedDate = date;
                return false;
            }
        });

        if (selectedDate) {
            return selectedDate;
        }

        var $selected = $main.find(
            '.rmdp-day.rmdp-selected, ' +
            '.rmdp-day.rmdp-active'
        ).first();

        if ($selected.length) {
            var label = $selected.find('[aria-label]')
                .first()
                .attr('aria-label');

            label = label || $selected.attr('aria-label');

            selectedDate = parseDeliveryDate(label);

            if (selectedDate) {
                return selectedDate;
            }
        }

        return null;
    }

    function isSelectedDateFriday() {
        var date = getSelectedDeliveryDate();

        if (!date) {
            console.log('No readable delivery date selected.');
            return false;
        }

        var isFriday = date.getDay() === 5;

        console.log(
            'Selected delivery date:',
            date.toDateString()
        );

        console.log('Is Friday:', isFriday);

        return isFriday;
    }

    // =========================================================
    // WHERE DO WE DELIVER TOOLTIP
    // =========================================================

    var DeliverTooltip = `
        <div class="added-where-do-we-deliver">

            <p class="awdwd-toggle"
               role="button"
               tabindex="0"
               aria-expanded="false">
                Where do we deliver?
            </p>

            <div class="awdwd-tooltip">

                <p class="header">
                    Our Delivery Areas
                </p>

                <p class="text">
                    We deliver within
                    <strong>20km Monday–Sunday</strong>,
                    with extended delivery up to
                    <strong>60km on Fridays only</strong>.
                </p>

            </div>
        </div>
    `;

    function insertDeliveryTooltip() {
        var $target = $(
            'cart-items .container > div:first'
        );

        if (
            $target.length &&
            !$target.find(
                '.added-where-do-we-deliver'
            ).length
        ) {
            $target.append(DeliverTooltip);
        }
    }

    function updateDeliveryTooltip() {
        if (activeDeliveryMode === 'pickup') {
            $('.added-where-do-we-deliver')
                .addClass('hide');
        } else {
            $('.added-where-do-we-deliver')
                .removeClass('hide');
        }
    }

    setTimeout(function () {
        insertDeliveryTooltip();
        updateDeliveryTooltip();
    }, 500);

    $(document).on(
        'click',
        '.awdwd-toggle',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $parent = $(this).closest(
                '.added-where-do-we-deliver'
            );

            var isOpen = $parent.hasClass('is-open');

            $('.added-where-do-we-deliver')
                .removeClass('is-open');

            $('.awdwd-toggle')
                .attr('aria-expanded', 'false');

            $parent.toggleClass('is-open', !isOpen);

            $(this).attr(
                'aria-expanded',
                String(!isOpen)
            );
        }
    );

    $(document).on(
        'keydown',
        '.awdwd-toggle',
        function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        }
    );

    $(document).on('click', function (e) {
        if (
            !$(e.target).closest(
                '.added-where-do-we-deliver'
            ).length
        ) {
            $('.added-where-do-we-deliver')
                .removeClass('is-open');

            $('.awdwd-toggle')
                .attr('aria-expanded', 'false');
        }
    });

    // =========================================================
    // DELIVERY TIME CONTROLS
    // =========================================================

    function enableDeliveryTime() {
        $(SELECTORS.time)
            .filter('.postcode-time-disabled')
            .css({
                'pointer-events': '',
                'opacity': ''
            })
            .removeClass('postcode-time-disabled');
    }

    function disableDeliveryTime() {
        // IMPORTANT:
        // Never disable time fields for Store Pickup
        // or Same Day Delivery.
        if (activeDeliveryMode !== 'future') {
            return;
        }

        $(SELECTORS.time)
            .css({
                'pointer-events': 'none',
                'opacity': '0.4'
            })
            .addClass('postcode-time-disabled');
    }

    function clearCustomTimeRestriction() {
        $('.postcode-time-disabled')
            .css({
                'pointer-events': '',
                'opacity': ''
            })
            .removeClass('postcode-time-disabled');
    }

    // =========================================================
    // CHECKOUT CONTROLS
    // =========================================================

    function disableCheckout() {
        // Only apply custom postcode checkout rules
        // to Schedule for Future Date.
        if (activeDeliveryMode !== 'future') {
            return;
        }

        getCheckoutButtons()
            .prop('disabled', true)
            .attr('aria-disabled', 'true')
            .addClass('postcode-checkout-disabled')
            .css({
                'pointer-events': 'none',
                'opacity': '0.5'
            });
    }

    function clearCustomCheckoutRestriction() {
        getCheckoutButtons().each(function () {
            var $button = $(this);

            if (
                !$button.hasClass(
                    'postcode-checkout-disabled'
                )
            ) {
                return;
            }

            $button
                .prop('disabled', false)
                .removeAttr('aria-disabled')
                .removeClass('postcode-checkout-disabled')
                .css({
                    'pointer-events': '',
                    'opacity': ''
                });
        });
    }

    function enableCheckout() {
        clearCustomCheckoutRestriction();
    }

    // =========================================================
    // ORIGINAL CUSTOM LOADER
    // =========================================================

    function showLoader() {
        $(SELECTORS.tabs)
            .addClass('is-loading');

        $('#loading-spinner').remove();

        var loader = `
            <div id="loading-spinner" style="
                position:relative;
                top:25px;
                width:100%;
                height:96px;
                background:#fff;
                z-index:9999;
            ">
                <div style="
                    position:absolute;
                    top:50%;
                    left:50%;
                    width:50px;
                    height:50px;
                    margin:-25px 0 0 -25px;
                    border:4px solid #e5e5e5;
                    border-top:4px solid #000;
                    border-radius:50%;
                    animation:spin 0.8s linear infinite;
                "></div>
            </div>
        `;

        if (!$('#postcode-spinner-style').length) {
            $('<style id="postcode-spinner-style">')
                .html(`
                    @keyframes spin {
                        100% {
                            transform: rotate(360deg);
                        }
                    }
                `)
                .appendTo('head');
        }

        $(loader).insertAfter(SELECTORS.tabs);

        $(SELECTORS.main)
            .stop(true, true)
            .fadeOut(0);
    }

    function hideLoader(duration) {
        $('#loading-spinner').remove();

        $(SELECTORS.tabs)
            .removeClass('is-loading');

        $(SELECTORS.main)
            .stop(true, true)
            .fadeIn(duration || 100);
    }

    function scheduleLoaderHide(
        delay,
        duration,
        changeId
    ) {
        clearTimeout(loaderTimeout);

        loaderTimeout = setTimeout(function () {
            if (changeId !== tabChangeId) {
                return;
            }

            hideLoader(duration);
        }, delay);
    }

    // =========================================================
    // TAB STATE MANAGEMENT
    // =========================================================

    function beginTabChange(mode) {
        tabChangeId++;

        clearTimeout(loaderTimeout);
        clearTimeout(checkerTimeout);
        clearTimeout(datesTimeout);

        activeDeliveryMode = mode;
        isDeliveryValid = false;

        updateDeliveryTooltip();

        // Remove restrictions from previous tab.
        clearCustomTimeRestriction();
        clearCustomCheckoutRestriction();

        showLoader();

        return tabChangeId;
    }

    // =========================================================
    // FUTURE DELIVERY POSTCODE CHECKER HTML
    // =========================================================

    var postCheck = `
        <div class="added-delivery-identixweb-order-delivery-date"
             style="margin-bottom:5px;">

            <p class="identixweb-order-delivery-date-uiHeading identixweb-order-delivery-date-local-delivery-Heading">
                Enter the delivery postcode to check availability.
            </p>

            <div class="order-delivery-date-postalcode-text identixweb-inputWithButton">

                <input
                    type="text"
                    placeholder="Enter your postal code ..."
                    class="order-delivery-date-postalcode identixweb-btn-text-input"
                    maxlength="4"
                    inputmode="numeric"
                    value=""
                >

                <a class="identixweb-snize-exclude-input orderDeliveryDatePostlCode added-orderDeliveryDatePostlCode"
                   href="#"
                   style="background-color:#4c347f">

                    <svg width="22"
                         height="22"
                         viewBox="0 0 22 22"
                         fill="none"
                         xmlns="http://www.w3.org/2000/svg">

                        <path
                            d="M14.054 14.0535L20.9998 21"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                        />

                        <circle
                            cx="8.647"
                            cy="8.647"
                            r="7.647"
                            stroke="white"
                            stroke-width="2"
                        />

                    </svg>
                </a>

            </div>

            <div class="error_msg"
                 style="
                    display:none;
                    color:red !important;
                    font-size:16px;
                    text-align:center;
                    padding-top:5px;
                 ">
            </div>

        </div>
    `;

    // =========================================================
    // SCHEDULE FOR FUTURE DATE
    // =========================================================

    $(document).on(
        'click',
        SELECTORS.future,
        function () {
            var changeId = beginTabChange('future');

            // Disable until postcode validation succeeds.
            disableDeliveryTime();
            disableCheckout();

            $cartChecker().remove();

            checkerTimeout = setTimeout(function () {
                if (
                    changeId !== tabChangeId ||
                    activeDeliveryMode !== 'future'
                ) {
                    return;
                }

                if (!$cartChecker().length) {
                    $(SELECTORS.main)
                        .prepend(postCheck);
                }
            }, 300);

            datesTimeout = setTimeout(function () {
                if (
                    changeId !== tabChangeId ||
                    activeDeliveryMode !== 'future'
                ) {
                    return;
                }

                $(SELECTORS.dates).fadeOut(0);
            }, 500);

            scheduleLoaderHide(
                500,
                100,
                changeId
            );
        }
    );

    // =========================================================
    // CART POSTCODE VALIDATION
    // =========================================================

    function validateDeliveryPostcode(userPostcode) {
        // Never validate for pickup or same-day.
        if (activeDeliveryMode !== 'future') {
            return false;
        }

        userPostcode = $.trim(
            String(userPostcode || '')
        );

        var item = findDelivery(userPostcode);

        var $inputWrapper = $cartChecker().find(
            '.order-delivery-date-postalcode-text'
        );

        var $error = $cartChecker().find(
            '.error_msg'
        );

        var $dates = $(SELECTORS.dates);

        function showError(message, showDates) {
            isDeliveryValid = false;

            $inputWrapper.addClass('error');

            $error
                .text(message)
                .show();

            if (showDates) {
                $dates.show();
            } else {
                $dates.hide();
            }

            disableDeliveryTime();
            disableCheckout();

            return false;
        }

        // INVALID POSTCODE FORMAT
        if (!/^\d{4}$/.test(userPostcode)) {
            return showError(
                'Please enter a valid 4-digit postcode.',
                false
            );
        }

        // POSTCODE NOT FOUND
        if (!item) {
            return showError(
                'Sorry, we do not currently deliver to this postcode.',
                false
            );
        }

        // INVALID DELIVERY PRICE
        if (!formatDeliveryPrice(item)) {
            return showError(
                'Delivery pricing is currently unavailable for this postcode.',
                false
            );
        }

        var day = getDeliveryDay(item);

        // DAILY DELIVERY
        if (day === 'daily') {
            isDeliveryValid = true;

            $inputWrapper.removeClass('error');
            $error.hide();
            $dates.show();

            enableDeliveryTime();
            enableCheckout();

            console.log(
                'Daily delivery valid:',
                item.code,
                'Price:',
                item.price
            );

            return true;
        }

        // FRIDAY-ONLY EXTENDED DELIVERY
        if (day === 'extended') {
            var fridaySelected = isSelectedDateFriday();

            if (fridaySelected) {
                isDeliveryValid = true;

                $inputWrapper.removeClass('error');
                $error.hide();
                $dates.show();

                enableDeliveryTime();
                enableCheckout();

                console.log(
                    'Friday-only delivery valid:',
                    item.code,
                    'Price:',
                    item.price
                );

                return true;
            }

            return showError(
                'This postcode is available for Friday delivery only. ' +
                'Please select a Friday delivery date.',
                true
            );
        }

        return showError(
            'Delivery is unavailable for this postcode.',
            false
        );
    }

    // =========================================================
    // POSTCODE CHECK BUTTON
    // =========================================================

    $(document).on(
        'click',
        '.added-orderDeliveryDatePostlCode',
        function (e) {
            e.preventDefault();

            if (activeDeliveryMode !== 'future') {
                return;
            }

            var postcode = $cartChecker().find(
                '.order-delivery-date-postalcode'
            ).val();

            validateDeliveryPostcode(postcode);
        }
    );

    // =========================================================
    // ENTER KEY
    // =========================================================

    $(document).on(
        'keydown',
        SELECTORS.checker +
        ' .order-delivery-date-postalcode',
        function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();

                if (activeDeliveryMode !== 'future') {
                    return;
                }

                $('.added-orderDeliveryDatePostlCode')
                    .trigger('click');
            }
        }
    );

    // =========================================================
    // POSTCODE INPUT CHANGE
    // =========================================================

    $(document).on(
        'input',
        SELECTORS.checker +
        ' .order-delivery-date-postalcode',
        function () {
            this.value = this.value
                .replace(/\D/g, '')
                .slice(0, 4);

            if (activeDeliveryMode !== 'future') {
                return;
            }

            isDeliveryValid = false;

            $cartChecker()
                .find('.error_msg')
                .hide();

            $cartChecker()
                .find('.order-delivery-date-postalcode-text')
                .removeClass('error');

            disableDeliveryTime();
            disableCheckout();

            $(SELECTORS.dates).hide();
        }
    );

    // =========================================================
    // REVALIDATE WHEN DELIVERY DATE CHANGES
    // =========================================================

    function revalidateCurrentPostcode() {
        // CRITICAL FIX:
        // Do not run on Store Pickup or Same Day.
        if (activeDeliveryMode !== 'future') {
            return;
        }

        var postcode = $cartChecker().find(
            '.order-delivery-date-postalcode'
        ).val();

        if ($.trim(postcode || '')) {
            validateDeliveryPostcode(postcode);
        } else {
            isDeliveryValid = false;

            disableDeliveryTime();
            disableCheckout();
        }
    }

    // Calendar date clicked.
    $(document).on(
        'click',
        '.rmdp-day:not(.rmdp-disabled)',
        function () {
            if (activeDeliveryMode !== 'future') {
                return;
            }

            setTimeout(function () {
                if (activeDeliveryMode === 'future') {
                    revalidateCurrentPostcode();
                }
            }, 150);
        }
    );

    // Date input changed.
    $(document).on(
        'change',
        SELECTORS.main + ' input',
        function () {
            if (activeDeliveryMode !== 'future') {
                return;
            }

            if (
                $(this).is(
                    '.order-delivery-date-postalcode'
                )
            ) {
                return;
            }

            setTimeout(function () {
                if (activeDeliveryMode === 'future') {
                    revalidateCurrentPostcode();
                }
            }, 100);
        }
    );

    // =========================================================
    // SAME DAY DELIVERY
    // =========================================================

    $(document).on(
        'click',
        SELECTORS.tabs + ' ' + SELECTORS.sameDay,
        function () {
            var changeId = beginTabChange('same-day');

            // Future delivery postcode checker
            // must not affect Same Day Delivery.
            $cartChecker().remove();

            clearCustomTimeRestriction();
            clearCustomCheckoutRestriction();

            setTimeout(function () {
                if (changeId !== tabChangeId) {
                    return;
                }

                $(
                    SELECTORS.main + ' ' + SELECTORS.sameDay
                ).fadeOut(0);
            }, 100);

            scheduleLoaderHide(
                500,
                100,
                changeId
            );

            setTimeout(function () {
                if (changeId !== tabChangeId) {
                    return;
                }

                $(SELECTORS.sameDay).fadeIn(50);
            }, 500);
        }
    );

    // =========================================================
    // STORE PICKUP - CUSTOM LOADER
    // =========================================================

    $(document).on(
        'click',
        SELECTORS.pickup +
        '.identixweb-order-delivery-tablinks',
        function () {
            var changeId = beginTabChange('pickup');

            // Remove future delivery postcode checker.
            $cartChecker().remove();

            // IMPORTANT:
            // Remove our custom restrictions, but do not
            // force Identixweb's own time fields to enable.
            clearCustomTimeRestriction();
            clearCustomCheckoutRestriction();

            // Hide "Where do we deliver?" on pickup.
            $('.added-where-do-we-deliver')
                .addClass('hide');

            // Preserve your existing 1-second loader.
            scheduleLoaderHide(
                1000,
                100,
                changeId
            );

            setTimeout(function () {
                if (
                    changeId !== tabChangeId ||
                    activeDeliveryMode !== 'pickup'
                ) {
                    return;
                }

                $(
                    '.store-pickup-identixweb-order-delivery-date ' +
                    '.identixweb-order-delivery-date-store'
                ).fadeIn(0);

            }, 1000);
        }
    );

    // =========================================================
    // CHECKOUT PROTECTION
    // =========================================================

    $(document).on(
        'click',
        SELECTORS.checkout,
        function (e) {
            // CRITICAL FIX:
            // Do not apply future delivery postcode rules
            // to Store Pickup or Same Day Delivery.
            if (activeDeliveryMode !== 'future') {
                return;
            }

            var postcode = $cartChecker().find(
                '.order-delivery-date-postalcode'
            ).val();

            var valid = false;

            if (postcode) {
                valid = validateDeliveryPostcode(postcode);
            }

            if (!valid) {
                e.preventDefault();
                e.stopImmediatePropagation();

                disableCheckout();

                var $error = $cartChecker().find(
                    '.error_msg'
                );

                if (!$error.is(':visible')) {
                    $error
                        .text(
                            'Please enter a valid delivery postcode ' +
                            'and select an available delivery date ' +
                            'before checkout.'
                        )
                        .show();
                }

                console.log(
                    'Checkout blocked: invalid future delivery'
                );

                return false;
            }
        }
    );

    // =========================================================
    // KEEP INVALID FUTURE CHECKOUT DISABLED
    // =========================================================

    setInterval(function () {
        // CRITICAL FIX:
        // Never disable checkout for Store Pickup
        // or Same Day Delivery using this checker.
        if (
            activeDeliveryMode === 'future' &&
            !isDeliveryValid
        ) {
            disableCheckout();
        }
    }, 500);

    // =========================================================
    // INITIAL TAB DETECTION
    // =========================================================

    function detectInitialDeliveryMode() {
        var $active = $(
            '.identixweb-order-delivery-tablinks'
        ).filter(
            '.active, .selected, .is-active, ' +
            '[aria-selected="true"]'
        ).first();

        if (!$active.length) {
            return;
        }

        if ($active.is(SELECTORS.future)) {
            activeDeliveryMode = 'future';

        } else if ($active.is(SELECTORS.sameDay)) {
            activeDeliveryMode = 'same-day';

        } else if ($active.is(SELECTORS.pickup)) {
            activeDeliveryMode = 'pickup';
        }

        updateDeliveryTooltip();
    }

    setTimeout(function () {
        if (!activeDeliveryMode) {
            detectInitialDeliveryMode();
        }

        if (activeDeliveryMode === 'future') {
            // Require postcode validation before checkout.
            disableDeliveryTime();
            disableCheckout();
        }
    }, 700);

    console.log(
        'Penelope cart postcode checker initialized.'
    );

});
